import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-lekhak-master',
  templateUrl: './lekhak-master.component.html',
  styleUrls: ['./lekhak-master.component.scss']
})
export class LekhakMasterComponent implements OnInit {

  lekhakForm!: FormGroup;
  lekhakList: any[] = [];
  loading = false;
  error = '';
  editMode = false;
  selectedId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.lekhakForm = this.fb.group({
      name: ['', Validators.required],
      mobile: [''],
      email: [''],
      acc_no: ['', Validators.required],
      ifsc: ['', Validators.required],
      bank_name: [''],
      branch: [''],
      rate: ['', Validators.required],
      status: ['Active']
    });

    // this.loadLekhak();
    this.loadDummyData();
  }

  loadLekhak() {
    this.loading = true;
    this.service.getLekhakList().subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.lekhakList = res.data;
          this.error = '';
        } else {
          this.lekhakList = [];
          this.error = 'No lekhak found';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load lekhak list';
        this.loading = false;
      }
    });
  }

  saveLekhak() {
    if (this.lekhakForm.invalid) return;

    this.loading = true;
    const payload = { ...this.lekhakForm.value, id: this.selectedId };

    const apiCall = this.editMode
      ? this.service.updateLekhak(payload)
      : this.service.addLekhak(payload);

    apiCall.subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.resetForm();
          this.loadLekhak();
        } else {
          this.error = res.message || 'Operation failed';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loading = false;
      }
    });
  }

  editLekhak(row: any) {
    this.editMode = true;
    this.selectedId = row.id;
    this.lekhakForm.patchValue(row);
  }

  deleteLekhak(id: number) {
    if (!confirm('Delete this lekhak?')) return;

    this.loading = true;
    this.service.deleteLekhak(id).subscribe({
      next: (res: any) => {
        if (res.status === 'success') {
          this.loadLekhak();
        } else {
          this.error = 'Delete failed';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Server error';
        this.loading = false;
      }
    });
  }

  resetForm() {
    this.lekhakForm.reset({ status: 'Active' });
    this.editMode = false;
    this.selectedId = null;
  }

  loadDummyData() {
    this.loading = true;

    setTimeout(() => {
      this.lekhakList = [
        {
          id: 1,
          name: 'Ram Patil',
          mobile: '9876543210',
          email: 'ram@gmail.com',
          acc_no: '123456789012',
          ifsc: 'SBIN0001234',
          bank_name: 'State Bank of India',
          branch: 'Pune',
          rate: 500,
          status: 'Active'
        },
        {
          id: 2,
          name: 'Shyam Deshmukh',
          mobile: '9123456789',
          email: 'shyam@gmail.com',
          acc_no: '987654321098',
          ifsc: 'HDFC0004567',
          bank_name: 'HDFC Bank',
          branch: 'Mumbai',
          rate: 600,
          status: 'Active'
        },
        {
          id: 3,
          name: 'Anita Kulkarni',
          mobile: '9012345678',
          email: 'anita@gmail.com',
          acc_no: '456789123456',
          ifsc: 'ICIC0007890',
          bank_name: 'ICICI Bank',
          branch: 'Nashik',
          rate: 550,
          status: 'Inactive'
        }
      ];

      this.loading = false;
    }, 500);
  }


}